import WildAppResource from "./WildAppResource";
import UserAppResource from './UserAppResource';
import BrokerAppResource from './BrokerAppResource';

class InviteeInfoAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'invitee-info';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'invitees/infos';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'email',
            'firstName',
            'lastName',
            'zohoId',
            'brokerUuid',
            'userUuid',
            'data',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            broker: BrokerAppResource,
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            broker: 'broker_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            email: {
                type: 'string',
                email: true,
                length: {
                    maximum: 255,
                },
            },
            firstName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default InviteeInfoAppResource;
